import Header from './components/Header';
import HeroSlider from './components/HeroSlider';
import About from './components/About';
import Services from './components/Services';
import HowItWorks from './components/HowItWorks';
import Differentials from './components/Differentials';
import CTASection from './components/CTASection';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

export default function HomePage() {
  return (
    <main className="font-sans" style={{ color: '#1A1A1A', overflowX: 'hidden' }}>
      <Header />
      <HeroSlider />
      <About />
      <Services />
      <HowItWorks />
      <Differentials />
      <CTASection />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </main>
  );
}
